import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { apiClientV2 } from '~/api/client';
import { CreatorGender } from '~/clientApi/creator.model';
import { queryClient } from '~/config/reactQueryConfig';
import {
  AGENCIES_COLLECTION_QUERY_KEY,
  AGENCY_MANAGEMENT_CREATORS_COLLECTION_QUERY_KEY,
  CREATOR_PROFILE_QUERY_KEY,
  GLOBAL_SEARCH_TALENT_QUERY_KEY,
  SAVED_LIST_CREATORS,
  TR_CREATORS_LIST_QUERY_KEY,
  WHALAR_MODE_TALENT_SEARCH_QUERY_KEY,
} from '~/queries/keys';
import { ICreator, ICreatorLocation } from '~/types';

type CreatorPayload = {
  igHandle?: string;
  ttHandle?: string;
  snapHandle?: string;
  ytHandle?: string;
  id?: string;
  firstName?: string;
  lastName?: string;
  location?: ICreatorLocation;
  gender?: CreatorGender | null;
  dateOfBirth?: string | null;
  biography?: string;
  category?: string;
};

type ReqPayload = {
  id: string;
  type: 'json' | 'formdata';
  creator: CreatorPayload | FormData;
};

export type AddPlatformResponse = {
  success: boolean;
  data: ICreator;
};

export const useAddPlatform = () => {
  return useMutation<AddPlatformResponse, AxiosError, ReqPayload>({
    mutationFn: ({ id, creator }: ReqPayload) =>
      apiClientV2
        .post(`/creators/${id}/platforms`, creator)
        .then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CREATOR_PROFILE_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [GLOBAL_SEARCH_TALENT_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [AGENCIES_COLLECTION_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [WHALAR_MODE_TALENT_SEARCH_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [TR_CREATORS_LIST_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [SAVED_LIST_CREATORS],
      });
      queryClient.invalidateQueries({
        queryKey: [AGENCY_MANAGEMENT_CREATORS_COLLECTION_QUERY_KEY],
      });
    },
  });
};
